import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';

export interface CashFlowFilter {
  companyId?: string;
  financialYearCode?: string;
  dateFrom?: string;
  dateTo?: string;
  locationId?: string;
  currencyCode?: string;
}

export interface CashFlowActivityLine {
  accountId: string;
  accountCode: string;
  accountName: string;
  cashFlowCategory: string;
  netMovement: number;
}

export interface CashFlowReportDto {
  companyId: string;
  financialYearCode: string;
  dateFrom: string;
  dateTo: string;
  currencyCode: string;
  operatingActivities: CashFlowActivityLine[];
  investingActivities: CashFlowActivityLine[];
  financingActivities: CashFlowActivityLine[];
  netOperating: number;
  netInvesting: number;
  netFinancing: number;
  netCashMovement: number;
  openingCashBalance: number;
  closingCashBalance: number;
}

export const cashFlowApi = {
  /** GET /api/v1/reports/cash-flow */
  getReport: (filter: CashFlowFilter) =>
    apiClient.get<ApiResponse<CashFlowReportDto>>('/reports/cash-flow', { params: filter }),
};
